export interface SeedFieldProps {
  label: string;
  value: string | null;
  /** Shown instead of the value while it is not known yet. */
  placeholder?: string;
}

/** A labelled hex value (seed, hash, ticket id), wrapped so it never overflows the sheet. */
export function SeedField({ label, value, placeholder = '—' }: SeedFieldProps) {
  return (
    <div className="flex flex-col gap-2">
      <span className="text-[14px] leading-[20px]" style={{ color: 'var(--fairness-muted)' }}>
        {label}
      </span>
      <code
        className="block rounded-[12px] px-4 py-3 font-sans text-[15px] leading-[22px] [overflow-wrap:anywhere]"
        style={{
          backgroundColor: 'var(--fairness-surface)',
          border: '1px solid var(--fairness-border)',
          color: 'var(--fairness-text)',
        }}
      >
        {value ?? placeholder}
      </code>
    </div>
  );
}
